import { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function MentorTurmas() {
  const { token } = useAuth();
  const [turmas, setTurmas] = useState([]);
  const [criando, setCriando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const load = () => api.get('/turmas', token).then(setTurmas);
  useEffect(() => { load(); }, [token]);

  const criar = async (e) => {
    e.preventDefault();
    setSalvando(true); setErro('');
    try {
      await api.post('/turmas', { nome, descricao }, token);
      setNome(''); setDescricao(''); setCriando(false);
      await load();
    } catch (err) { setErro(err.message || 'Erro ao criar turma'); }
    finally { setSalvando(false); }
  };

  const salvarEdicao = async (e) => {
    e.preventDefault();
    setSalvando(true); setErro('');
    try {
      await api.patch(`/turmas/${editando.id}`, { nome, descricao }, token);
      setNome(''); setDescricao(''); setEditando(null);
      await load();
    } catch(err) { setErro(err.message || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };

  const excluir = async (id, nome) => {
    if (!window.confirm(`Excluir turma "${nome}"?`)) return;
    await api.del(`/turmas/${id}`, token);
    setTurmas(prev => prev.filter(t => t.id !== id));
  };

  const iniciarEdicao = (t) => {
    setEditando(t);
    setNome(t.nome);
    setDescricao(t.descricao || '');
    setCriando(false);
  };

  return (
    <div style={{padding:'28px 32px',maxWidth:600}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
        <div>
          <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Turmas</div>
          <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Gerencie as turmas do programa</div>
        </div>
        <button className="btn-primary" onClick={()=>{setCriando(true);setEditando(null);setNome('');setDescricao('');}}>+ Nova Turma</button>
      </div>

      {/* Modal criar/editar */}
      {(criando || editando) && (
        <div className="card" style={{marginBottom:16,borderLeft:'3px solid #1A2ECC'}}>
          <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>{editando?`Editar: ${editando.nome}`:'Nova Turma'}</div>
          <form onSubmit={editando?salvarEdicao:criar}>
            <input className="input-field" placeholder="Nome da turma (ex: Turma Janeiro 2026)"
              value={nome} onChange={e=>setNome(e.target.value)} required autoFocus style={{marginBottom:10}} />
            <input className="input-field" placeholder="Descrição (opcional)"
              value={descricao} onChange={e=>setDescricao(e.target.value)} style={{marginBottom:10}} />
            {erro && <div style={{color:'#D63B3B',fontSize:12,marginBottom:8}}>{erro}</div>}
            <div style={{display:'flex',gap:8}}>
              <button className="btn-primary" type="submit" disabled={salvando||!nome.trim()}>
                {salvando?'Salvando...':editando?'Salvar alterações':'Criar turma'}
              </button>
              <button className="btn-ghost" type="button" onClick={()=>{setCriando(false);setEditando(null);setErro('');}}>Cancelar</button>
            </div>
          </form>
        </div>
      )}

      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <div style={{padding:'12px 18px',borderBottom:'0.5px solid #E4E6EF',fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em'}}>
          {turmas.length} turma{turmas.length!==1?'s':''}
        </div>
        {turmas.length===0 && <div style={{padding:24,textAlign:'center',color:'#6B7289',fontSize:13}}>Nenhuma turma cadastrada.</div>}
        {turmas.map(t=>(
          <div key={t.id} style={{display:'flex',alignItems:'center',gap:14,padding:'14px 18px',borderBottom:'0.5px solid #E4E6EF'}}>
            <div style={{width:36,height:36,borderRadius:10,background:'#EBF0FF',color:'#1028A0',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:14,flexShrink:0}}>
              {t.nome[0].toUpperCase()}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>{t.nome}</div>
              <div style={{fontSize:11,color:'#6B7289',marginTop:2}}>
                {t.total_alunos} aluno{t.total_alunos!=1?'s':''}{t.descricao?' · '+t.descricao:''}
              </div>
            </div>
            <div style={{display:'flex',gap:6}}>
              <button onClick={()=>iniciarEdicao(t)}
                style={{fontSize:11,color:'#1A2ECC',background:'#EEF1FF',border:'none',borderRadius:6,padding:'5px 10px',cursor:'pointer'}}>
                Editar
              </button>
              <button onClick={()=>excluir(t.id, t.nome)}
                style={{fontSize:11,color:'#D63B3B',background:'#FDEAEA',border:'none',borderRadius:6,padding:'5px 10px',cursor:'pointer'}}>
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
